import "./footer.css"
const Footer = () =>{
    return(
        <footer>
            <a href="https://www.instagram.com/savan.efam/?igshid=YmMyMTA2M2Y%3D" target="_blank" rel="noreferrer" className="social-container"><i className="fa-brands fa-instagram"></i></a>
        </footer>
    )
}

export default Footer;